import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AppHeader, PageShell } from "@/components/AppHeader";

const googleLogin = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/coach";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export default function AuthPage() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/coach" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const u = mode === "login" ? await api.login({ email: form.email, password: form.password }) : await api.register(form);
      setUser(u);
      navigate("/coach");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };
  const field = (k) => ({ value: form[k], onChange: (e) => setForm({ ...form, [k]: e.target.value }) });

  return (
    <PageShell>
      <AppHeader />
      <div className="max-w-md mx-auto pt-4 sm:pt-10">
        <div className="card space-y-5 !p-6">
          <div>
            <h1 className="font-heading text-4xl font-extrabold uppercase tracking-tight">Coach {mode === "login" ? "login" : "sign up"}</h1>
            <p className="text-sm text-[var(--muted)] font-medium mt-1">Free account. Build your team's playbook and share it with players.</p>
          </div>
          <div className="seg-group w-full">
            <button type="button" data-testid="auth-tab-login" className={`seg-btn flex-1 ${mode === "login" ? "seg-btn-active" : ""}`} onClick={() => setMode("login")}>Log in</button>
            <button type="button" data-testid="auth-tab-register" className={`seg-btn flex-1 ${mode === "register" ? "seg-btn-active" : ""}`} onClick={() => setMode("register")}>Sign up</button>
          </div>
          <form onSubmit={submit} className="space-y-3">
            {mode === "register" && <input data-testid="auth-name-input" className="field-input w-full" placeholder="Your name" required {...field("name")} />}
            <input data-testid="auth-email-input" type="email" className="field-input w-full" placeholder="Email" required {...field("email")} />
            <input data-testid="auth-password-input" type="password" className="field-input w-full" placeholder="Password (6+ characters)" required minLength={6} {...field("password")} />
            {error && <p className="text-sm font-bold text-red-600" data-testid="auth-error">{error}</p>}
            <button data-testid="auth-submit-button" className="btn-primary w-full" disabled={busy}>
              {busy && <Loader2 size={18} className="animate-spin" />} {mode === "login" ? "Log in" : "Create account"}
            </button>
          </form>
          <div className="flex items-center gap-3 text-xs font-bold uppercase text-[var(--muted)]"><span className="h-px flex-1 bg-[var(--line)]" />or<span className="h-px flex-1 bg-[var(--line)]" /></div>
          <button data-testid="google-login-button" className="btn-ghost w-full" onClick={googleLogin}>Continue with Google</button>
        </div>
      </div>
    </PageShell>
  );
}
